import Head from './../components/Head.vue';
import Footer from '../components/Footer.vue';
export default {
  components: {
    Head,
    Footer
  },
  data() {
    return {
      id: 0,
      newsDetail: null,
      module_name: '',
      caseBuildList: [],
      caseLevelList: [],
      caseLevelId: 0,
      total: 0,
      pageSize: 6,
      pageNum: 1
    };
  },
  created() {
    this.id = this.$utils.getUrlParams('id');
    this.getCaseLevelList();
  },
  methods: {
    async getCaseLevelList() {
      const res = await this.$http.getCaseLevelList();
      this.caseLevelList = res.filter(item => item.name !== '校级案例');
      this.caseLevelId = this.caseLevelList[0] && this.caseLevelList[0].id || '';
      this.getCaseBuildList();
    },
    async getCaseBuildList() {
      const res = await this.$http.getCaseBuildList({
        keyWord: this.keyWord,
        caseTypeId: this.id,
        year: '',
        caseLevelId: this.caseLevelId,
        caseThemeId: '',
        '_pageable.page': this.pageNum - 1,
        '_pageable.size': this.pageSize
      });
      this.caseBuildList = res.content;
      this.total = +res.totalElements;
    },
    handlePageChange(pageNum) {
      this.pageNum = pageNum;
      this.getCaseBuildList();
    },
    handleSearchCase() {
      window.location.href = `/caseList.html?caseTypeId=${this.id}`;
    },
    handleCaseLevelChange(id) {
      this.caseLevelId = id;
      this.getCaseBuildList();
    },
    handleCaseClick(item) {
      window.location.href = `/caseDetail.html?siteId=${item.sitId}`;
    }
  }
};